
import Vue from 'vue';
import loginScreenMixin from './login-screen-mixin';

export default Vue.extend({
  name: 'LoginGuestplan',
  mixins: [loginScreenMixin],
  props: { },
  data() { return { }; },
  watch: { },
  methods: { },
});
